import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=647ad67c&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=ts&"
export * from "./Customer.vue?vue&type=script&lang=ts&"
import style0 from "./Customer.vue?vue&type=style&index=0&id=647ad67c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ad67c",
  null
  
)

export default component.exports